import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { reduxForm, Field } from 'redux-form';
import Switch from 'components/UIForm/Switch';
import NewComment from './newComment';
import Log from './log';

import styles from './styles.scss';

@reduxForm({
  form: 'cardHistoryFilter',
  destroyOnUnmount: false,
  initialValues: {
    isCreateView: true,
    isOwnerView: true,
    isStatusView: true,
    isCommentView: true,
    isDocumentView: true,
    isEditView: true,
    isSourceLostView: true,
  },
})
export default class TenderHistory extends React.PureComponent {
  static propTypes = {
    tenderId: PropTypes.number.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    logs: PropTypes.arrayOf(PropTypes.object),
    commentAdd: PropTypes.bool,
    commentView: PropTypes.bool,
    documentsView: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    switchers: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  static defaultProps = {
    logs: [],
    commentAdd: false,
    commentView: false,
    documentsView: false,
  };
  render() {
    const { logs, tenderId, commentAdd, switchers, commentView, documentsView } = this.props;
    let date = {
      month: null,
      year: null,
    };

    return (
      <div className={styles.historyWrapper}>
        <div className={styles.header}>История изменений</div>
        <div className={styles.historyBody}>
          <div className={styles.history}>
            {commentAdd && <NewComment tenderId={tenderId} />}
            <div className={styles.logs}>
              {logs &&
                logs.length > 0 &&
                logs.map(e => {
                  const actionDate = dayjs(e.actionDate).utc();
                  const newMonth = actionDate.format('M');
                  const newYear = actionDate.format('YYYY');
                  let changeMonth = false;
                  if (date.year !== newYear || date.month !== newMonth) {
                    changeMonth = true;
                    date = {
                      month: newMonth,
                      year: newYear,
                    };
                  }
                  return <Log {...e} key={e.tenderLogId} actionDate={actionDate} changeMonth={changeMonth} />;
                })}
              {logs && logs.length === 0 && (
                <h1 style={{ marginTop: 20, marginLeft: 363, marginRight: 362 }}>Ничего не найдено</h1>
              )}
            </div>
          </div>
          <div className={styles.filter} style={{ marginTop: commentAdd ? 88 : 70 }}>
            {switchers.create !== 0 && (
              <div className={styles.switchWrapper}>
                <Field name="isCreateView" component={Switch} text="Создание тендера" size="small" />
              </div>
            )}
            {switchers.owner !== 0 && (
              <div className={styles.switchWrapper}>
                <Field name="isOwnerView" component={Switch} text="Изменение ответственного" size="small" />
              </div>
            )}
            {switchers.status !== 0 && (
              <div className={styles.switchWrapper}>
                <Field name="isStatusView" component={Switch} text="Изменение статуса" size="small" />
              </div>
            )}
            {commentView && switchers.comment !== 0 && (
              <div className={styles.switchWrapper}>
                <Field name="isCommentView" component={Switch} text="Комментарии" size="small" />
              </div>
            )}
            {documentsView && (
              <div className={styles.switchWrapper}>
                <Field name="isDocumentView" component={Switch} text="Документы" size="small" />
              </div>
            )}
            {switchers.edit !== 0 && (
              <div className={styles.switchWrapper}>
                <Field name="isEditView" component={Switch} text="Изменение тендера" size="small" />
              </div>
            )}
            {switchers.sourceLost !== 0 && (
              <div className={styles.switchWrapper}>
                <Field name="isSourceLostView" component={Switch} text="Связь с источником" size="small" />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
